export const isUrlProtocolValid = (urlString, allowedProtocols) => {
  try {
    const givenURL = new URL(urlString)
    return allowedProtocols.includes(givenURL.protocol)
  } catch (error) {
    return false
  }
}

export const isValidUrl = urlString => {
  return isUrlProtocolValid(urlString, ["https:"])
}
